import React, { useState } from "react";
import { IFacultyMembersData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import { getVisibleTabs, truncateText } from "../../exports/functions";
import TabSidebar from "../TabSidebar";
import { useHashScroll } from "../../hooks/custom/useHashScroll";

const Item = ({
  src,
  name,
  title,
}: {
  src: string;
  name: string;
  title: string;
}) => {
  return (
    <div className="td_team td_style_3 text-center position-relative">
      {/* <div className="td_team_thumb_wrap td_mb_20"> */}
      {/* <div className="td_team_thumb"> */}
      <img
        src={src}
        alt=""
        className="td_mb_20"
        style={{
          width: "128px",
          height: "128px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      {/* </div> */}
      {/* <img src={shape} className="td_team_thumb_shape" alt="" /> */}
      {/* </div> */}

      <div className="td_team_info td_white_bg td_mb_30">
        <h3 className="td_team_member_title td_fs_20 td_semibold td_mb_5">
          {name}
        </h3>
        <div style={{ padding: "0px 20px", marginBottom: "5px" }}>{title}</div>
      </div>
    </div>
  );
};

const FacultyMembers = (props: {
  internationalVisitingFaculties: IFacultyMembersData[];
}) => {
  const mobile = useMobile();
  const [openSidebar, setOpenSidebar] = useState(false);
  const handleTabHash = (hash: string) => {
    const tabLink = document.querySelector(
      `.td_tab_links a[href="${hash}"]`,
    ) as HTMLAnchorElement | null;
    tabLink?.click();
  };

  useHashScroll(120, handleTabHash);

  const [activeTab, setActiveTab] = useState<string>("#td_tab_1");

  const handleTabClick = (hash: string) => {
    setActiveTab(hash);
  };

  const allTabs = React.useMemo(
    () => [{ id: "#td_tab_1", label: "International Visiting Faculties" }],
    [],
  );

  const visibleTabs = React.useMemo(() => {
    return getVisibleTabs(allTabs, activeTab, mobile ? 2 : 4);
  }, [allTabs, activeTab, mobile]);

  return (
    <div>
      <section id="faculty-members">
        <div className="td_height_120 td_height_lg_40" />
        <div className="td_about td_style_1">
          <div className="container">
            <div
              className="td_section_heading td_style_1 text-center wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.15s"
            >
              <h2 className="td_section_title td_fs_48 mb-0">
                Faculty Members
              </h2>
              <div className="td_height_30 td_height_lg_30" />
            </div>

            <div className="td_height_30 td_height_lg_30" />

            <div className="td_tabs td_style_1">
              <ul className="td_tab_links td_style_2 td_type_2 td_mp_0 td_medium td_fs_16 td_heading_color align-items-center justify-content-between">
                <div className="td_tab_links td_style_2">
                  {visibleTabs.map((tab) => (
                    <li
                      key={tab.id}
                      className={activeTab === tab.id ? "active" : ""}
                    >
                      <a
                        href={tab.id}
                        onClick={() => handleTabClick(tab.id)}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={tab.label}
                      >
                        {truncateText(tab.label, mobile ? 10 : 50)}
                      </a>
                    </li>
                  ))}
                </div>
                {mobile && (
                  <li>
                    <div className="course_sidebar_toggle_wrapper">
                      <button
                        className="course_sidebar_toggle mt-1"
                        onClick={() => setOpenSidebar(true)}
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                        {/* <span></span>
                        <span></span>
                        <span></span> */}
                      </button>
                    </div>
                  </li>
                )}
              </ul>

              <div className="td_tab_body td_fs_18">
                <div className="td_tab active" id="td_tab_1">
                  <div className="row td_gap_y_30">
                    {props?.internationalVisitingFaculties?.map(
                      (member, index) => (
                        <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                          <Item
                            src={`${process.env.REACT_APP_cmsUrl}${member?.image[0]?.media?.url}`}
                            name={member?.name}
                            title={member?.position}
                          />
                        </div>
                      ),
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TabSidebar
        title="Faculty Members"
        tabs={allTabs}
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
      />
    </div>
  );
};

export default FacultyMembers;
